import { container } from "tsyringe";
export class UseCaseGetDaysDifference {
    async handle(pickUpDateTime, returnDateTime) {
        const getDaysDifference = container.resolve("iGetDaysDifference");
        const totalDays = await getDaysDifference.handle(pickUpDateTime, returnDateTime);
        return totalDays;
    }
}
